import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/view-dict',
    name: 'ViewDict',
    component: () => import('#/views/view-dict/index'),
    meta: {
      title: 'View Dict',
      ignoreAccess: true,
    },
  },
  {
    name: 'MicroPreload',
    path: '/micro-preload',
    component: () => import('#/views/_core/micro-preload.vue'),
  },
]

export default routes
